// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionBar_actionBar__4LCsy {
  position: fixed;
  width: 85%;
  bottom: 0;
  right: 0;
  background-color: #fff;
  border-radius: 8px;
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: space-between;
  box-shadow: 0 -4px 10px rgba(0,8,3,0.09);
}

.ActionBar_actionBar__count__RHbL\\+ {
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
}

.ActionBar_actionBar__buttons__mAPNw button {
  margin-right: 16px;
  padding: 8.5px 12px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.ActionBar_redButton__pMRph {
  background-color: #e74c3c ;
  color: white;
}

.ActionBar_redButton__pMRph:hover {
  background-color: #c0392b ;
}

.ActionBar_blackButton__9ap9x {
  background: rgba(25, 29, 35, 1);
  color: white;
}

.ActionBar_grayButton__aftvq {
  border: 1px solid rgba(115, 115, 115, 1);
  color: rgba(115, 115, 115, 1);
}`, "",{"version":3,"sources":["webpack://./src/styles/ActionBar.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B","sourcesContent":[".actionBar {\n  position: fixed;\n  width: 85%;\n  bottom: 0;\n  right: 0;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 24px 48px;\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: space-between;\n  box-shadow: 0 -4px 10px rgba(0,8,3,0.09);\n}\n\n.actionBar__count {\n  font-weight: 600;\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.actionBar__buttons button {\n  margin-right: 16px;\n  padding: 8.5px 12px;\n  font-size: 14px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.redButton {\n  background-color: #e74c3c ;\n  color: white;\n}\n\n.redButton:hover {\n  background-color: #c0392b ;\n}\n\n.blackButton {\n  background: rgba(25, 29, 35, 1);\n  color: white;\n}\n\n.grayButton {\n  border: 1px solid rgba(115, 115, 115, 1);\n  color: rgba(115, 115, 115, 1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionBar": `ActionBar_actionBar__4LCsy`,
	"actionBar__count": `ActionBar_actionBar__count__RHbL+`,
	"actionBar__buttons": `ActionBar_actionBar__buttons__mAPNw`,
	"redButton": `ActionBar_redButton__pMRph`,
	"blackButton": `ActionBar_blackButton__9ap9x`,
	"grayButton": `ActionBar_grayButton__aftvq`
};
export default ___CSS_LOADER_EXPORT___;
